const { body } = document;
const elements = document.querySelectorAll(
    '.animation-init > *:not(.block-animation)'
);
const breakpointController = window.matchMedia(
    'screen and (min-width: 1025px)'
);
const controllClass = 'animation-fired';

let observer = new IntersectionObserver(
    (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
                entry.target.classList.add('animation-start');

                const customCursors = entry.target.querySelectorAll(
                    '.custom-cursor'
                );

                if (customCursors.length) {
                    setTimeout(() => {
                        entry.target.style.transform = 'none';
                    }, 500);
                }
                observer.unobserve(entry.target);
            }
        });
    },
    { threshold: 0.15 }
);

let observerBigElements = new IntersectionObserver(
    (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
                entry.target.classList.add('animation-start');

                const customCursors = entry.target.querySelectorAll(
                    '.custom-cursor'
                );

                if (customCursors.length) {
                    setTimeout(() => {
                        entry.target.style.transform = 'none';
                    }, 500);
                }
                observer.unobserve(entry.target);
            }
        });
    },
    { threshold: 0.01 }
);

const contentAnimations = () => {
    if (
        elements.length &&
        !!window.IntersectionObserver &&
        breakpointController.matches &&
        !body.classList.contains(controllClass)
    ) {
        body.classList.add(controllClass);
        elements.forEach((el) => {
            if (el.hasAttribute('data-animation-large')) {
                observerBigElements.observe(el);
            } else {
                observer.observe(el);
            }
        });
    }
};

const breakpointCheck = (e) => {
    if (!e.matches && body.classList.contains(controllClass)) {
        body.classList.remove(controllClass);
        observer.disconnect();
        observerBigElements.disconnect();
    } else {
        contentAnimations();
    }
};

export const contentAnimationResize = () => {
    if (!elements.length) {
        return;
    }
    if (breakpointController.addListener) {
        breakpointController.addListener((e) => breakpointCheck(e));
    } else {
        breakpointController.addEventListener('change', (e) =>
            breakpointCheck(e)
        );
    }
};

export default contentAnimations;